import {z} from 'zod'

export const settingsSchema = z.object({
  instantFeedback: z.boolean().default(true),
  shuffleQuestions: z.boolean().default(false),
  showProgressBar: z.boolean().default(true),
  primaryColor: z.string().default('#f59e0b'),
  emoji: z.string().default('🌴'),
})

export type SummerSettings = z.infer<typeof settingsSchema>
